import $ from 'jquery';
import { throttle } from 'lodash';
import BaseView from '../core/baseView';

export default BaseView.extend({
  initialize() {
    this.$clone = this.$el.clone();
    this.$placeholder = $(document.createElement('div'))
      .append(this.$clone)
      .addClass('js-sticky-placeholder')
      .insertBefore(this.$el);
    this.sticky = false;
    this.toggleScrollListener();
    this.bindResizeListener();
  },

  toggleScrollListener() {
    if ($(window).width() < 768) {
      this.bindScrollListener();
    } else {
      this.unbindScrollListener();
      this.disableStickyness();
    }
  },

  bindScrollListener() {
    $(window)
      .off('scroll.stickybottom')
      .on('scroll.stickybottom', throttle(this.toggleStickyness.bind(this), 16))
      .trigger('scroll.stickybottom');
  },

  unbindScrollListener() {
    $(window).off('scroll.stickybottom');
  },

  bindResizeListener() {
    $(window).on(
      'resize.stickybottom',
      throttle(this.toggleScrollListener.bind(this), 16)
    );
  },

  toggleStickyness() {
    var $window = $(window);
    var windowScroll = $window.scrollTop();
    // $window.height() gives incorrect value on mobile devices
    var windowHeight = window.innerHeight;
    if (this.sticky) {
      var placeholderOffsetTop = this.$placeholder.offset().top;
      var placeholderOuterHeight = this.$placeholder.outerHeight();
      var placeholderStickyOffset =
        placeholderOffsetTop + placeholderOuterHeight - windowHeight;
      if (placeholderStickyOffset < windowScroll) {
        this.disableStickyness();
      }
    } else {
      var elOffsetTop = this.$el.offset().top;
      var elOuterHeight = this.$el.outerHeight();
      var elStickyOffset = elOffsetTop + elOuterHeight - windowHeight;
      if (elStickyOffset >= windowScroll) {
        this.enableStickyness();
      }
    }
  },

  enableStickyness() {
    this.sticky = true;
    this.$placeholder.addClass('js-sticky-placeholder--active');
    this.$el.addClass('fixed-to-bottom');
  },

  disableStickyness() {
    this.sticky = false;
    this.$placeholder.removeClass('js-sticky-placeholder--active');
    this.$el.removeClass('fixed-to-bottom');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/stickyBottomView.js
 **/